module.exports = __webpack_public_path__ + "static/media/financeHead2.b87839b3.jpg";